//Pagos que agrupan facturas desde ERP UM
export const invoicesAdapter = (orders) => {
    return orders.map((order) => ({
        amount: order.amount || 0,
        createDate: order.create_date || '-',
        currency: order.currency,
        estimatedPaymentDate: order.estimated_payment_date || '-',
        id: order.id,
        name: order.name,
        paymentMethod: order.payment_method_id || '-',
        ref: order.ref,
        responsible: order.responsible || '-',
        state: order.state,
        purchaseOrders: order.purchase_orders.map((po) => ({
            activityDate: po.activity_date || '-',
            amount: po.amount || 0,
            company: po.company || '-',
            currency: po.currency || 'USD',
            id: po.id,
            createDate: po.load_date || '-',
            name: po.name,
            paymentDate: po.payment_date || '-',
            ref: po.ref || '-',
            responsible: po.responsible || '-',
            pOrderState: po.state || '-',
            type: po.type || '-',
            /*esta previsto que una OC pueda tener mas de una factura */
            invoiceName: po.invoices[0].name || '-',
            invoiceId: po.invoices[0].id || '-',
            invoiceAmount: po.invoices[0].amount || '-',
            invCurrency: po.invoices[0].currency || 'USD',
            state: po.invoices[0].move_payment_state || '-',
            invState: po.invoices[0].state || '-',
            invoiceRef: po.invoices[0].payment_ref || '-',
            invoiceDate: po.invoices[0].invoice_date || '-',

            // invoices: po.invoices.map((inv) => ({
            //     invAmount: inv.amount || 0,
            //     invCurrency: inv.currency || 'USD',
            //     invCreateDate: inv.load_date || '-',
            //     invoiceDate: inv.invoice_date || '-',
            //     invDueDate: inv.due_date || '-',
            //     invId: inv.id,
            //     movePaymentState: inv.move_payment_state,
            //     invName: inv.name || '',
            //     ref: inv.payment_ref || '-',
            //     invState: inv.state || '-',
            // })),
        })),
    }));
};
